import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
import { Router } from '@angular/router'; // import router from angular router
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from "rxjs/operators";
import { GlobalConstants } from '../app.component';
import { APIService } from '../common/api.component';
import { APIData } from '../common/APIData';
import { Constants } from '../common/constants';
import { ErrorData } from '../common/ErrorData';
import { SharedService } from '../common/shared.service';
import { ShareUtils } from '../common/shareutils';
import { Utils } from '../common/utils.component';
import { ShareLink } from '../models/sharelink';
import { SortByPipe } from '../pipes/sort-by.pipe';

@Component({
  selector: 'app-sites',
  templateUrl: './sites.component.html'

})
export class SitesComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  isUpload: any;
  clickedRow: any;
  // sharetitle: string;
  activeSort: string;
  share = new ShareLink();
  mysite: object;
  private onDestroy$: Subject<void> = new Subject<void>();
  isShare: boolean;

  constructor(
    private apiService: APIService,
    private utils: Utils,
    private sharedService: SharedService,
    private route: Router,
    private dialog: MatDialog,
    private shareUtils: ShareUtils,
    private sortbyPipe: SortByPipe) {
    this.subscription = sharedService.searchedText$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        searchText => {
          this.clearErrorMsg()
          this.searchText = searchText;
        });

    this.subscription = sharedService.activeSort$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        activeSort => {
          this.activeSort = activeSort;
          this.setSortOptions(true, false)
        });

    this.subscription = sharedService.isShare$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        isShare => {
          this.isShare = isShare;
          if (!this.isShare) {
            this.sharebutton.isDisabled = true
          }
        });

    this.clickedRow = function (item) {
      this.highlightRow = item;
      this.sharebutton.isDisabled = false;
    }
  }
  highlightRow: any;
  IsSiteLoaded: boolean = false;
  offset: number = 0;
  limit: number = 50;
  pages: number = 0;
  currentPage: number = 0;
  sites: object[];
  loading: boolean = true;
  isButtonVisible: boolean = false;
  searchText;
  //  isDisabled: boolean = true;
  loadingMessage: string;
  uploadToHQ = Constants.UPLOAD_FILE_TO_HQ
  errorMsg = { str: "" }
  sharebutton = { isDisabled: true, sharetitle: "", sharetitledefault: Constants.SHARE_LINK }

  // sharetitledefault = Constants.SHARE_LINK
  noSites = Constants.NO_SITES


  ngOnInit() {
    this.apiService.ValidateMsTeamContextAndFatchTeamsId(this.sharedService);
    this.apiService.setTheme();
    this.sharedService.setLoading(this.loading);
    this.sharedService.setInsideFolderfiles(false);
    this.sharedService.setSeachText("")
    this.isUpload = this.sharedService.isUploadFlow$.getValue();
    this.activeSort = this.sharedService.currentactiveSort$.getValue();
    if (this.activeSort === undefined || (this.activeSort != "nameaz" && this.activeSort != "nameza")) {
      this.activeSort = "nameaz"
      this.sharedService.setSort(this.activeSort)
    }

    this.getSitesFirstCall();
  
    if (localStorage.getItem(Constants.SHOW_DIALOG_STORAGE) === 'true' || localStorage.getItem(Constants.SHOW_DIALOG_STORAGE) === 'undefined' || localStorage.getItem(Constants.SHOW_DIALOG_STORAGE) == null)
      this.sharebutton.sharetitle = Constants.NEXT;
    else
      this.sharebutton.sharetitle = Constants.SHARE_LINK;
  }

  shareItem() {
    this.clearErrorMsg()
    var site = this.highlightRow
    var siteFolderobj = {
      filefoldername: site.sitename,
      types: 'folder',
      fileType: null,
      contentId: site.sitefolderID,
      locations: site.sitename,
      fileSize: null,
      lastmodified: site.createddate,
      foldertype: 'Normal',
    }
    if (localStorage.getItem(Constants.SHOW_DIALOG_STORAGE) === 'true' || localStorage.getItem(Constants.SHOW_DIALOG_STORAGE) === 'undefined' || localStorage.getItem(Constants.SHOW_DIALOG_STORAGE) == null) {
      this.utils.openDialog(this.apiService, this.dialog, siteFolderobj, this.shareUtils, this.share, false, this.sharedService, this.errorMsg, this.sharebutton);
    } else {
      this.sharebutton.sharetitle = Constants.GENERATING_LINK
      this.sharebutton.isDisabled = true;
      if (localStorage.getItem(Constants.LINKEXPIRES_STORAGE) != null) {
        this.shareUtils.generateSharelink(siteFolderobj, this.share, this.apiService, null, this.utils, this.dialog, this.shareUtils, this.sharedService, this.errorMsg, this.sharebutton)
      } else {
        this.utils.getSettings(this.apiService, this.dialog, false, siteFolderobj, this.shareUtils, this.share, false, this.sharedService, this.errorMsg, this.sharebutton)
      }
    }
  }

  ngAfterViewChecked() {
    this.utils.setContentHeight(this.isButtonVisible, true, this.isUpload, false, false);
    if (GlobalConstants.Tid.length > 0) {
      if (this.IsSiteLoaded)
        return;
      this.IsSiteLoaded = true;
    }
  }

  public closeMSTeamApp() {
    if (this.sharedService.isUploadFlow$.getValue()) {
      // this.sharedService.uploadFile$.next(null);
      // this.sharedService.isUploadFlow$.next(false);
      this.route.navigate(['upload'])
    } else {
      this.sharedService.uploadFile$.next(null);
      this.sharedService.isUploadFlow$.next(false);
      this.apiService.submitTask(null);
    }
  }
  getSitesFirstCall() {
    this.apiService.getSitesFirstCall(Constants.MY_SITE, this.offset, this.limit, this.activeSort)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (data) =>{
        this.pages = Number(data[1]['sitecount']) / this.limit;

        this.mysite = data[0]['site'][0];
        this.setSiteData(data[1], false)
        },
        error: (errdata) => {
        this.loading = false
        this.sharedService.setLoading(this.loading);
        /* this.utils.openErrorDialog({ errorData: errdata }, this.dialog, item => {
          // Error callback can be put here
        }) */
        this.errorMsg.str = errdata.errorMsg

        }
    });
  }

  setSiteData(data, fromloadMore: boolean) {

    if (data['site'].length < this.limit || data['site'].length > this.limit) {
      this.isButtonVisible = false;
    } else {
      this.isButtonVisible = true;
      this.loadingMessage = Constants.LOAD_MORE_RESULTS
    }


    if (this.sites) {
      for (let item of data['site'])
        this.sites.push(item);
    }
    else {
      this.sites = data['site'];
    }
    if (this.sites.length != 1)
      this.sites = this.sites.filter(datas => !datas['mysite'])
    this.loading = false;
    this.sharedService.setLoading(this.loading);
    this.setSortOptions(false, fromloadMore)
  }

  public getSites(fromloadMore) {
    this.apiService.getSites(this.offset, this.limit, this.activeSort)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (data) =>{
        this.setSiteData(data, fromloadMore)
      },
      error: (errdatas) => {
        this.errorMsg.str = errdatas.errorMsg
        this.sharedService.setLoading(this.loading);
        this.loading = false
      }
    });
  }

  public resetParameters() {
    this.offset = 0;
    this.sites = undefined;
  }

  resetAndCallApI() {
    this.clearErrorMsg()
    this.resetParameters();
    this.isButtonVisible = false;
    this.getSites(false);
  }
  setSortOptions(issortChanged: boolean, fromloadMore: boolean) {
    this.clearErrorMsg()
    if (this.activeSort == 'nameaz' || this.activeSort == 'nameza') {
      if (issortChanged && this.isButtonVisible) {
        this.loading = true;
        this.sharedService.setLoading(this.loading);
        this.loadingMessage = Constants.LOADING
        this.resetAndCallApI()
      }
      else {
        if (this.sites && this.sites[0]['mysite']) {
          this.mysite = this.sites[0];
          this.sites = this.sites.slice(1, this.sites.length);
        }
        if (!fromloadMore)
          this.sites = this.sortbyPipe.transform(this.sites, true, this.activeSort == 'nameaz' ? 'asc' : 'desc', 'sitename');
        if (this.mysite)
          this.sites.unshift(this.mysite)
      }
    }
  }

  public loadMore() {
    this.clearErrorMsg()
    if (this.currentPage < this.pages) {
      this.currentPage++;
      this.offset += this.limit;
      this.loadingMessage = Constants.LOADING
      this.getSites(true);
    } else {
      this.isButtonVisible = false;
    }
  }
  clearErrorMsg() {
    this.errorMsg.str = ""
  }

  clearSearchField() {
    this.clearErrorMsg()
    this.searchText = '';
  }

  public getFolderInfo(site: any, isUpload) {
    this.loading = true
    this.sharedService.setLoading(this.loading);
    this.clearErrorMsg()
    this.apiService.getFolderInfo(site.sitefolderID)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (data) =>{
        this.route.navigate([`/folder/${site.sitefolderID}/Browse/${site.sitename}`], { state: { siteId: site.id, siteName: site.sitename, siteLastModified: site.createddate,overrideDuplicate: this.getOverrideDuplicateFlag(site), duplicateFileDetectionLevel: this.getDuplicateFileDetectionLevel(site)}});
      },
      error: (err) => {
        if (err.refCode >= 432 && err.refCode <= 434) {
          this.apiService.getSite(site.id).subscribe(data => {
            this.loading = false
            this.sharedService.setLoading(this.loading);
            err.sites = this.utils.getSiteTemp(data, site.id)
            err.apiData = this.gatherAPIData(site.sitefolderID, site.sitename, site.id)
            this.utils.openErrorDialog({ errorData: err }, this.dialog, item => {
              if (item == true) {
                if (isUpload) {
                  this.route.navigateByUrl('/upload', { state: { parentFolderId: site.sitefolderID, isShareLink: false, siteId: site.id, uploadPath: site.sitename,overrideDuplicate: this.getOverrideDuplicateFlag(site), duplicateFileDetectionLevel: this.getDuplicateFileDetectionLevel(site) } });
                } else {
                  this.route.navigate(['/folder', site.sitefolderID, 'Browse', site.sitename], { state: { siteId: site.id, siteName: site.sitename, siteLastModified: site.createddate,overrideDuplicate: this.getOverrideDuplicateFlag(site), duplicateFileDetectionLevel: this.getDuplicateFileDetectionLevel(site) } });
                }
              } else if (!item) {
                this.errorMsg.str = item
              }
            })
          }, errdatas => {
            this.loading = false
            this.sharedService.setLoading(this.loading);
            /*  this.utils.openErrorDialog({ errorData: errdatas }, this.dialog, item => {
               // Error callback can be put here
             }) */
            this.errorMsg.str = errdatas.errorMsg
          })
        } else {
          this.loading = false
          this.sharedService.setLoading(this.loading);
          /* this.utils.openErrorDialog({ errorData: err }, this.dialog, item => {
            // Error callback can be put here
          }) */
          this.errorMsg.str = err.errorMsg
        }
      }
      });
  }
  gatherAPIData(sitefolderID: any, sitename: any, siteId): any {
    var apiData = new APIData()
    apiData.apiToCall = Constants.WS_SITE
    apiData.parentFolderId = sitefolderID
    var arr = []
    arr.push(sitename)
    arr.push(siteId)
    apiData.additionalData = arr
    return apiData
  }

  public showFolders(siteId, folderId) {
    this.route.navigate(['/folder', siteId, folderId]);
  }

  uploadItem() {
    this.clearErrorMsg()
    var site = this.highlightRow
    if (site.isSyncable == 0) {
      if (site.siteRestrictionType.passwordprotected == 1 || site.siteRestrictionType.twoFactorAuthentication == 1 || site.siteRestrictionType.termsandconditions == 1) {
        this.getFolderInfo(site, true)
      } else if (site.iprestrictedsite == 1) {
        var errorData = new ErrorData()
        errorData.errorMsg = Constants.IP_RES_ERR_MSG
        this.errorMsg.str = errorData.errorMsg
        /* this.utils.openErrorDialog({ errorData: errorData }, this.dialog, item => {
          // Error callback can be put here
        }) */
      } else {
        this.route.navigateByUrl('/upload', { state: { parentFolderId: site.sitefolderID, isShareLink: false, siteId: site.id, uploadPath: site.sitename, overrideDuplicate: this.getOverrideDuplicateFlag(site), duplicateFileDetectionLevel: this.getDuplicateFileDetectionLevel(site) } });
      }

    } else {
      this.route.navigateByUrl('/upload', { state: { parentFolderId: site.sitefolderID, isShareLink: false, siteId: site.id, uploadPath: site.sitename, overrideDuplicate: this.getOverrideDuplicateFlag(site), duplicateFileDetectionLevel: this.getDuplicateFileDetectionLevel(site) } });
    }

  }

  getOverrideDuplicateFlag(site: any) {
    if (!site.file.hasOwnProperty('fileDuplication') || site.file.fileDuplication === null || !site.file.fileDuplication.enableDuplicateFileDetection) {
      return false;
    }
    else {
      return true;
    }
  }

  getDuplicateFileDetectionLevel(site: any) {
    if (this.getOverrideDuplicateFlag(site) && site.file.fileDuplication.hasOwnProperty('duplicateFileDetectionLevel'))
      return site.file.fileDuplication.duplicateFileDetectionLevel;

    return 0;
  }

  closeDialog() {
    this.shareUtils.closeMainDialog(this.apiService);
  }

  public ngOnDestroy(): void {
    this.subscription.remove(this.subscription);
    this.subscription.unsubscribe();
    this.onDestroy$.next();
  }
}
